import actions from './actions';
import mutations from './mutations';

const state = () => ({
  screenSize: 1024,
  isMobile: false,
  isTablet: false,
  isDesktop: true,
  usdToVndExchangeRate: null,
  lastExchangeRateSetAt: null,
  locale: 'en',
  userSelectedLocale: false,
  purchasedStories: []
});

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
